exports.validateUrlName = (name, category) => {
  const valid = name && name.trim();
  const format = /^[ A-Za-z0-9_-]*$/;
  let validData = format.test(name);
  if (!validData) {
    return ` should not contain special characters other than -_`;
  } else if (!valid) {
    return ` is required`;
  } else {
    return undefined;
  }
};
exports.getSuccessMessage = () => {
  return {
    status: 'success',
    message: 'Changes Saved'
  };
};
exports.getFailMessage = () => {
  return {
    status: 'error',
    message: 'Error saving, please try again'
  };
};

let isSaved;

exports.setState = state => {
  isSaved = state;
};

exports.getState = () => {
  let temState = isSaved;
  isSaved = false;
  return temState;
};

exports.validateNumber = number => {
  if (isNaN(number) || !number || number <= 0) {
    return false;
  } else {
    return true;
  }
};

exports.validateLatitude = number => {
  let address = {};
  const format = /^(?:-?[0-9]{0,2}.?[0-9]{0,5})?$/;
  address.isValidLatitude = format.test(number);

  if (address.isValidLatitude) {
    if (parseFloat(number) < -90 || parseFloat(number) > 90) {
      address.isValidLatitude = false;
      address.errorMessageId = 2;
    }
  }
  return address;
};

exports.validateLongitude = number => {
  let address = {};
  const format = /^(?:-?[0-9]{0,3}.?[0-9]{0,5})?$/;
  address.isValidLongitude = format.test(number);

  if (address.isValidLongitude) {
    if (parseFloat(number) < -180 || parseFloat(number) > 180) {
      address.isValidLongitude = false;
      address.errorMessageId = 2;
    }
  }

  return address;
};

let isLocationSaved;
let locationType;

exports.setLocationState = (state, type) => {
  isLocationSaved = state;
  locationType = type;
};

exports.getLocationStatus = () => {
  let message;
  if (isLocationSaved) {
    message = `Your new ${locationType} location has been created`;
  }
  return {
    status: isLocationSaved,
    message: message
  };
};

exports.resetLocationStatus = () => {
  isLocationSaved = false;
  locationType = '';
};

let isOperatorSaved;
let operatorName;

exports.setOperatorState = (state, name) => {
  isOperatorSaved = state;
  operatorName = name;
};

exports.getOperatorSavedMessage = () => {
  return {
    status: isOperatorSaved,
    message: `${operatorName} has been successfully updated.`
  };
};

exports.resetOperatorStatus = () => {
  isOperatorSaved = false;
  operatorName = '';
};

exports.isEmpty = data => {
  if (!data) {
    return false;
  } else {
    return true;
  }
};

let isMultiStoreKioskSaved;
let multiStoreKioskMessage;

exports.setMultiStoreKioskChanges = (state, message) => {
  isMultiStoreKioskSaved = state;
  multiStoreKioskMessage = message;
};

exports.getMultiStoreKioskChanges = () => {
  return {
    status: isMultiStoreKioskSaved,
    message: multiStoreKioskMessage
  };
};

exports.resetMultiStoreKioskChanges = () => {
  isMultiStoreKioskSaved = false;
  multiStoreKioskMessage = '';
};

let isCategorySaved;
let categorySavedMessage;

exports.setCategoryChanges = (state, message) => {
  isCategorySaved = state;
  categorySavedMessage = message;
};

exports.getCategoryChanges = () => {
  return {
    status: isCategorySaved,
    message: categorySavedMessage
  };
};

exports.resetCategoryChanges = () => {
  isCategorySaved = false;
  categorySavedMessage = '';
};

exports.trimText = value => {
  if (value) {
    return value.trim();
  } else {
    return value;
  }
};
